"use client";

import { LoginForm } from "@features/login/login-form";
import { useRouter } from "@/i18n/navigation";
import { useSearchParams } from "next/navigation";
import { AuthControls } from "@components/ui/auth-controls";

export default function Page() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const redirect = searchParams.get("redirect");

  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm">
        <div className="mb-4 flex justify-end">
          <AuthControls />
        </div>
        <LoginForm
          onClose={() => router.push("/")}
          onSwitchToSignup={() =>
            router.push(`/auth/sign-up${redirect ? `?redirect=${encodeURIComponent(redirect)}` : ""}`)
          }
          onSwitchToForgot={() => router.push("/auth/forgot-password")}
        />
      </div>
    </div>
  );
}
